// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/hooks/useCrmDashboard.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { crmDashboardService } from '../services/crmDashboardService';

export const useCrmDashboard = (mesesEvolucao = 12, diasAtraso = 1) =>
  useQuery({
    queryKey: ['crm', 'dashboard', mesesEvolucao, diasAtraso],
    queryFn:  () => crmDashboardService.obter(mesesEvolucao, diasAtraso),
  });

export const useCrmAlertas = (diasAtraso = 1) =>
  useQuery({
    queryKey: ['crm', 'dashboard', 'alertas', diasAtraso],
    queryFn:  () => crmDashboardService.listarAlertas(diasAtraso),
    refetchInterval: 60_000,
  });
